import axios from 'axios';
import storage from '@/utils/localStorage';
import commonConstants from '@/constants/common';

const getCookie = (name) => {
  const cookies = document.cookie.split('; ').reduce((obj, data) => {
    const [key, value] = data.split('=');
    return { ...obj, [key]: value };
  }, {});
  return cookies[name] || '';
};

// Create axios instance for Legacy API
const legacyInstance = axios.create({
  baseURL: process.env.VUE_APP_LEGACY_API || 'http://localhost:3006/api',
  timeout: 30000,
});

// Request interceptor - 使用相同的認證機制
legacyInstance.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('wuwow_token');
    if (!token) {
      token = getCookie('wuwow_token');
    }
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (storage.role === commonConstants.ROLE.PARENT) {
      const parentParams = {
        vipId: storage.vipId,
        user_type: 'vip_parents',
      };
      if (config.params === undefined) {
        config.params = parentParams;
      } else {
        Object.assign(config.params, parentParams);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
legacyInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && document.location.pathname !== '/') {
      if (process.env.VUE_APP_ALLOW_UNAUTHORIZED === 'true') {
        document.location.href = process.env.VUE_APP_LOGIN_URL;
      }
    }
    return Promise.reject(error);
  }
);

export default legacyInstance;
